// Data/Components/ResourceEditorPanel.tsx
import React from "react";
import { CuttingProgress } from "../../Controls/Progress/CuttingProgress";
import "./css/ResourceEditorPanel.css";

interface Props<T> {
    controller: {
        data: T | null;
        loading: boolean;
        error: string | null;
        saving: boolean;
        saveError: string | null;
        saveComplete: boolean;
        save: (data: T) => Promise<void>;
        setData: React.Dispatch<React.SetStateAction<T | null>>;
    };
    children: (resource: {
        data: T;
        setData: React.Dispatch<React.SetStateAction<T | null>>;
        save: (data: T) => Promise<void>;
    }) => React.ReactNode;
}

export function ResourceEditorPanel<T>({ controller, children }: Props<T>) {
    const { data, loading, error, saving, saveError, setData, save } = controller;

    const showOverlay = loading || saving || error || saveError;

    return (
        <div className="resource-editor-panel">
            {/* Consumer UI */}
            {data && children({ data, setData, save })}

            {/* Overlay */}
            {showOverlay && (
                <div className="resource-editor-overlay">
                    <div className="resource-editor-overlay-content">
                        <CuttingProgress text={loading ? "Loading…" : saving ? "Saving…" : ""} />
                    </div>
                </div>
            )}
        </div>
    );
}
